import { observable, action } from 'mobx';

export class AccountOverlay {
    @observable public isOverlayVisible: boolean = false;

    @action
    public setVisibility = (newState: boolean) => {
        this.isOverlayVisible = newState;
    };

    @action
    public toggle = () => {
        this.isOverlayVisible = !this.isOverlayVisible;
    };
}
